import React from 'react';
import { CountdownTimer } from './CountdownTimer';
const comparisonRows = [{
  without: '❌ Ore ogni settimana a cercare esercizi',
  with: '✅ Tutto già pianificato'
}, {
  without: '❌ Allenamenti improvvisati',
  with: "✅ Allenamenti pronti all'uso"
}, {
  without: '❌ Progressione assente',
  with: '✅ Progressione completa U6-U14'
}, {
  without: '❌ Bambini poco coinvolti',
  with: '✅ Bambini più coinvolti'
}, {
  without: '❌ Nessuna struttura stagionale',
  with: "✅ Stagione organizzata dall'inizio alla fine"
}];
const offer = {
  emoji: '🏆',
  title: '⚽ CALCIO GIOVANILE PRONTO',
  description: '5 Volumi + 5 Bonus',
  originalPrice: '€67',
  price: '€19,90',
  ctaText: '⚽ VOGLIO CALCIO GIOVANILE PRONTO ORA',
  ctaHref: 'https://basket-pronto.impultienda.ar/checkout',
  savings: 'RISPARMI €47'
};
export function FinalCTA() {
  return <section className="w-full bg-[#0A0A0A] py-20 px-4" data-id="element-39">
      <div className="max-w-2xl mx-auto" data-id="element-40">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white text-center mb-8 tracking-tight leading-tight" data-id="element-41">
          Il prossimo allenamento puoi continuare a improvvisare.{' '}
          <br className="hidden md:block" data-id="element-42" />
          <span className="text-[#16A34A]" data-id="element-43">
            Oppure puoi entrare in campo con tutto già pronto.
          </span>
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 text-white font-bold text-sm sm:text-base mb-12 uppercase tracking-wider" data-id="element-44">
          <span data-id="element-45">Allenamenti.</span>
          <span className="text-[#333]" data-id="element-46">/</span>
          <span data-id="element-47">Esercizi.</span>
          <span className="text-[#333]" data-id="element-48">/</span>
          <span data-id="element-49">Progressioni.</span>
          <span className="text-[#333]" data-id="element-50">/</span>
          <span data-id="element-51">Programmazione.</span>
          <span className="text-[#333]" data-id="element-52">/</span>
          <span className="text-[#00C853]" data-id="element-53">Tutto organizzato.</span>
        </div>

        <div className="bg-[#16161F] border border-[#16A34A33] rounded-2xl overflow-hidden mb-12 shadow-2xl" data-id="element-54">
          <div className="grid grid-cols-2 bg-[#0A0A0A] border-b border-[#16A34A33]" data-id="element-55">
            <div className="px-4 py-4 font-black text-[#B0B0C0] text-xs sm:text-sm text-center uppercase tracking-wider" data-id="element-56">
              Senza Calcio Giovanile Pronto
            </div>
            <div className="px-4 py-4 font-black text-[#16A34A] text-xs sm:text-sm text-center border-l border-[#16A34A33] uppercase tracking-wider" data-id="element-57">
              Con Calcio Giovanile Pronto
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-[#16A34A33]' : ''}`} data-id="element-58">
              <div className="px-4 py-4 text-[#B0B0C0] text-xs sm:text-sm font-medium" data-id="element-59">
                {row.without}
              </div>
              <div className="px-4 py-4 text-white font-bold text-xs sm:text-sm bg-[#16A34A]/5 border-l border-[#16A34A33]" data-id="element-60">
                {row.with}
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8" data-id="element-61">
          <CountdownTimer size="md" blinking={true} data-id="element-62" />
        </div>

        <div className="max-w-xl mx-auto mb-8" data-id="element-63">
          <div className="relative bg-[#16161F] border-2 border-[#16A34A] rounded-2xl p-6 shadow-[0_0_40px_rgba(22,163,74,0.15)] overflow-hidden" data-id="element-64">
            <div className="absolute top-0 right-0 bg-[#16A34A] text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-65">
              🏆 PACCHETTO COMPLETO
            </div>

            <div className="flex items-center gap-2 mb-2 mt-3 sm:mt-0" data-id="element-66">
              <span className="text-xl" data-id="element-67">{offer.emoji}</span>
              <span className="text-white font-black text-base sm:text-lg tracking-tight" data-id="element-68">
                {offer.title}
              </span>
            </div>
            <p className="text-[#B0B0C0] text-sm font-medium mb-5" data-id="element-69">
              {offer.description}
            </p>

            <div className="flex items-end justify-between" data-id="element-70">
              <div data-id="element-71">
                <div className="text-[#B0B0C0] line-through text-sm font-bold mb-1" data-id="element-72">
                  {offer.originalPrice}
                </div>
                <div className="font-black text-4xl sm:text-5xl text-white tracking-tighter leading-none" data-id="element-73">
                  {offer.price}
                </div>
              </div>
              <span className="inline-block bg-[#00C853]/15 text-[#00C853] text-xs font-black px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-74">
                {offer.savings}
              </span>
            </div>
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-75">
          <a href={offer.ctaHref} className="btn-cta-green block w-full text-center font-black text-lg sm:text-2xl py-6 rounded-2xl transition-colors shadow-2xl mb-6" data-id="element-76">
            {offer.ctaText}
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-[#B0B0C0] font-bold" data-id="element-77">
            <span className="flex items-center gap-1.5" data-id="element-78">
              🔒 Pagamento Sicuro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-79">
              ⚡ Accesso Immediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-80">
              🛡️ Garanzia 7 Giorni
            </span>
            <span className="flex items-center gap-1.5" data-id="element-81">💳 Carta · PayPal</span>
          </div>
        </div>
      </div>
    </section>;
}